import { render, staticRenderFns } from "./FilesModule.vue?vue&type=template&id=257ff055&"
import script from "./FilesModule.vue?vue&type=script&lang=js&"
export * from "./FilesModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports